import {useNavigate, useSearchParams} from "react-router-dom";
import {useEffect, useRef, useState, useCallback} from "react";
import axios from "axios";
import {setAuthData} from "../redux/main/action/main";
import {useDispatch} from "react-redux";
import Welcome from "../ui/Welcome";
import styles from "../styles/pages/AuthRedirectProcess.module.css";

const routeConvertor = {
    dashboard: "dashboard",
    bot: "bot-automation",
    api: "developer-api",
    services: "pricing-billing/activate-services",
    subscription: "pricing-billing/subscription",
    referrals: "pricing-billing/referrals",
    ai: "ai-assistant/assistant",
    alert: "alert-system",
    insight: "insight",
    portfolio: "portfolio",
    simulator: "trade-simulator",
    mnptf: "mini-portfolio",
    mnset: "mini-settings",
};

function AuthRedirectProcess() {
    const [searchParams, setSearchParams] = useSearchParams();
    const tokenRef = useRef(null);

    const token =
        searchParams.get("authToken") || localStorage.getItem("authToken");
    const nextPath = searchParams.get("next") || localStorage.getItem("next");

    const [errorMessage, setErrorMessage] = useState("");
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const controllerRef = useRef(null);

    const loginWithToken = useCallback(
        async (tokenValue) => {
            controllerRef.current = new AbortController();
            const {signal} = controllerRef.current;
            setLoading(true);
            setErrorMessage("");
            try {
                const {data} = await axios.post(
                    "https://0znr1xesf9.execute-api.ap-southeast-2.amazonaws.com/dev/api",
                    {
                        operation_mode: "token_login",
                        token: tokenValue,
                    },
                    {signal},
                );

                const {
                    idToken: {jwtToken, payload: userData},
                    refreshToken: {token: refreshToken},
                } = data || {};

                dispatch(setAuthData(userData, jwtToken, refreshToken));
                axios.defaults.headers.common.Authorization = `Bearer ${jwtToken}`;

                // TODO: redirect logic here
                // if (nextPath) navigate(nextPath);
                // else navigate("/dashboard");
                if (routeConvertor?.[nextPath]) {
                    navigate(`/${routeConvertor?.[nextPath]}`);
                } else {
                    navigate("/dashboard");
                }
            } catch (error) {
                console.error(error);
                setErrorMessage("Authentication failed!");
            } finally {
                setLoading(false);
            }
        },
        [dispatch, navigate, nextPath],
    );

    useEffect(() => {
        if (token && !loading && !errorMessage) {
            localStorage.setItem("authToken", token);
            localStorage.setItem("next", nextPath);
            tokenRef.current = token;
            setSearchParams({});
            return loginWithToken(token);
        }
    }, [token, nextPath, setSearchParams, loginWithToken, loading, errorMessage]);

    useEffect(() => {
        return () => {
            if (controllerRef.current) {
                controllerRef.current.abort();
            }
            localStorage.removeItem("authToken");
            localStorage.removeItem("next");
        };
    }, []);

    return (
        <div className={styles.container}>
            {!errorMessage && <Welcome/>}
            {errorMessage && (
                <div className={styles.errorBox}>
                    <h4>{errorMessage}</h4>
                    <span className={styles.tryBtn} onClick={() => loginWithToken(token)}>
            Try again
          </span>
                </div>
            )}
        </div>
    );
}

export default AuthRedirectProcess;
